import {
  IconArrowAutofitContent,
  IconArrowDown,
  IconArrowsSort,
  IconBoxMultiple,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsDown,
  IconCircleOff,
  IconCircleX,
  IconClearAll,
  IconColumns,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconEdit,
  IconEyeOff,
  IconFilter,
  IconFilterOff,
  IconGripHorizontal,
  IconMaximize,
  IconMinimize,
  IconPinned,
  IconPinnedOff,
  IconSearch,
  IconSortAscending,
  IconSortDescending,
  IconTallymark1,
  IconTallymark2,
  IconTallymark3,
  IconTallymark4,
  IconTallymarks,
  IconX,
} from '@tabler/icons-react';

export interface MRT_Icons {
  IconArrowAutofitContent: any;
  IconArrowDown: any;
  IconArrowsSort: any;
  IconBoxMultiple: any;
  IconChevronDown: any;
  IconChevronLeft: any;
  IconChevronRight: any;
  IconChevronUp: any;
  IconChevronsDown: any;
  IconCircleOff: any;
  IconCircleX: any;
  IconClearAll: any;
  IconColumns: any;
  IconDeviceFloppy: any;
  IconDots: any;
  IconDotsVertical: any;
  IconEdit: any;
  IconEyeOff: any;
  IconFilter: any;
  IconFilterOff: any;
  IconGripHorizontal: any;
  IconMaximize: any;
  IconMinimize: any;
  IconPinned: any;
  IconPinnedOff: any;
  IconSearch: any;
  IconSortAscending: any;
  IconSortDescending: any;
  IconTallymark1: any;
  IconTallymark2: any;
  IconTallymark3: any;
  IconTallymark4: any;
  IconTallymarks: any;
  IconX: any;
}

export const MRT_Default_Icons: MRT_Icons = {
  IconArrowAutofitContent,
  IconArrowDown,
  IconArrowsSort,
  IconBoxMultiple,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsDown,
  IconCircleOff,
  IconCircleX,
  IconClearAll,
  IconColumns,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconEdit,
  IconEyeOff,
  IconFilter,
  IconFilterOff,
  IconGripHorizontal,
  IconMaximize,
  IconMinimize,
  IconPinned,
  IconPinnedOff,
  IconSearch,
  IconSortAscending,
  IconSortDescending,
  IconTallymark1,
  IconTallymark2,
  IconTallymark3,
  IconTallymark4,
  IconTallymarks,
  IconX,
};
